import Http from '@/api/http';
import BaseApi from '@/api/lib/baseApi';

export const $http = new Http();

export const $api = new BaseApi();
